import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../../assets/js/utils/Api";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import { Link as RouterLink } from "react-router-dom";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import ReactTable from "react-table";
import LoaderComponent from "../../components/Loader";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LinkIcon from '@material-ui/icons/Link';
import ChartistGraph from "react-chartist";

const PdfAnalytics = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;

        this.state = {
            loading: false,
            recent_visits: null,
            most_engaged_contacts: null,
            visit_stats: null,
            recent_links: null,
        }
    }
    componentDidMount(){
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }

        this.loadPdfAnalyticsDashboard();
    }
    loadPdfAnalyticsDashboard(){
        const source = axios.CancelToken.source();
        
        this.setState({
            loading: true, 
            showError: false, 
            cancelToken: source,
        });

        let requestData = {};
        
        Api.getPdfAnalyticsDashboard(requestData, source).then(data => {
            this.setState({
                recent_visits: data.recent_visits,
                most_engaged_contacts: data.most_engaged_contacts,
                visit_stats: data.visit_stats,
                recent_links: data.recent_links,
                loading: false,
            });
        }).catch(err => {
            console.log(err);
        });
    }
    getTrProps(state, rowInfo){
        return {}
    }
    getTrGroupProps(state, rowInfo){
        if (rowInfo && rowInfo.row) {
            return {
                className: (rowInfo.original.id === 0 ? 'frozen_row' : '')
            }
        }else{
            return {}
        }
    }
    getNoDataProps(){
        return { style: { display: 'none' } };
    }
    getColumns(){
        let columns = [
            {
                Header: "Email",
                accessor: "email",
                headerClassName: "hd_email",
                className: "hd_email td_email",
                sortable: false
            },
            {
                Header: "File Name",
                accessor: "file_name",
                headerClassName: "hd_name",
                className: "hd_name td_name",
                sortable: false
            },
            {
                Header: "Time Spent",
                accessor: "time_spent",
                headerClassName: "hd_timespent",
                className: "hd_timespent td_timespent",
                sortable: false
            },
            
        ];

        return columns;
    }
    getTableData(){
        const { recent_visits } = this.state;
        if(recent_visits === null){
            return [];
        }
        let tableData = [];
        recent_visits.map(file => {
            let fileArray = {
                id: file.id,
                email: (
                    <div className="row">
                        <span className="user-icon">
                            { file.email.charAt(0) }
                        </span>
                        <div>
                            <p className="email">{file.email}</p>
                            <p className="views">{file.created_at}</p>
                        </div>
                    </div>
                ),
                file_name: (
                    <div>
                        <RouterLink to={"/user/pdf/analytics/"+file.id} className="row icon-column link">
                            <LinkIcon /> { file.file_name }
                        </RouterLink>
                        <p className='row path' title={file.path}>{file.path}</p>
                    </div>
                ),
                time_spent: (
                    <div className="row icon-column">
                        <AccessTimeIcon/> { file.time_spent }
                    </div>
                ),
            };
            tableData.push(fileArray);
            return null;
        });
        return tableData;
    }
    renderRecentVisits(){
        const { classes } = this.props;
        const { loading, limit } = this.state;
        const tableData = this.getTableData();

        return (
            <div className="section-container recent-visits-section">
                <h4 className="section-title">Recent Visits</h4>
                <div className="section-content">
                    <div className={classes.files}>
                        {
                            loading ?
                                <LoaderComponent color="custom" align="center" />
                            :
                                <ReactTable
                                    columns={this.getColumns()}
                                    data={tableData}
                                    pageSizeOptions={[500]}
                                    defaultPageSize={limit}
                                    showPaginationTop={false}
                                    minRows={0}
                                    showPaginationBottom={false}
                                    className={"-striped -highlight "+ (loading ? classes.loading : "")+" "+classes.filesTable}
                                    getTrProps={(state, rowInfo) => this.getTrProps(state, rowInfo)}
                                    getTrGroupProps={(state, rowInfo) => this.getTrGroupProps(state, rowInfo)}
                                    getNoDataProps={() => this.getNoDataProps()}
                                />
                        }
                    </div>
                </div>
            </div>
        )
    }
    renderMostEngagedContacts() {
        const { classes } = this.props;
        const { most_engaged_contacts, loading } = this.state;

        return (
            <div className="section-container most-engaged-section">
                <h4 className="section-title">Most engaged contacts <span className="">Last 30 days</span></h4>
                <div className="section-content">
                    {
                        loading ?
                            <LoaderComponent color="custom" align="center" />
                        :
                            most_engaged_contacts && most_engaged_contacts.length > 0 ? 
                                most_engaged_contacts.map((contact, key) => (
                                    <div key={key} className="row">
                                        <span className="number">{key+1}</span>
                                        <div>
                                            <p className="email">{contact.email}</p>
                                            <p className="views">Views: {contact.views}</p>
                                        </div>
                                    </div>
                                ))
                            : 
                                <div className={classes.noData}>No data</div>
                    }
                </div>
            </div>
        );
    }
    renderRecentLinks() {
        const { classes } = this.props;
        const { recent_links, loading } = this.state;

        return (
            <div className="section-container recent-links-section">
                <h4 className="section-title">Recent links</h4>
                <div className="section-content">
                    {
                        loading ?
                            <LoaderComponent color="custom" align="center" />
                        :
                            recent_links && recent_links.length > 0 ? 
                                recent_links.map((link, key) => (
                                    <div key={key} className="row">
                                        <RouterLink to={"/user/pdf/analytics/"+link.id} className="name">{link.file_name}</RouterLink>
                                        <p className={"date"}>Last accessed {link.created_at}</p>
                                    </div>
                                ))
                            : 
                                <div className={classes.noData}>No data</div>
                            
                    }
                </div>
            </div>
        );
    }
    renderVisitStats() {
        const { classes } = this.props;
        const { visit_stats, loading } = this.state;
        
        let chartData = [];
        if(visit_stats){
            chartData = {
                labels: visit_stats.map(item => item.date),
                series: [visit_stats.map(item => item.count)]
            };
        }

        const options = {
            low: 0,
            showArea: true
        };

        return (
            <div className="section-container visit-stats-section">
                <div className="section-title">Visit stats</div>
                <div className="section-content">
                    {
                        loading ?
                            <LoaderComponent color="custom" align="center" />
                        :
                            visit_stats ?
                                <ChartistGraph data={chartData} options={options} type="Line" />
                            :
                                <div className={classes.noData}>No data</div>
                    }
                </div>
            </div>
        );
    }
    render() {
        const { classes } = this.props;
        const { authorized } = this.store.getState();
        
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" "+classes.pdfAnalyticsMainContainer}>
                    <div className={classes.content}>
                        <GridItem>
                            <div className={classes.pdfAnalyticsContainer}>
                                <h3 className={classes.title}>PDF Analytics</h3>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} lg={8}>
                                        { this.renderRecentVisits() }
                                        {this.renderVisitStats()}
                                    </GridItem>
                                    <GridItem xs={12} sm={6} lg={4}>
                                        { this.renderMostEngagedContacts() }
                                        { this.renderRecentLinks() }
                                    </GridItem>
                                </GridContainer>
                            </div>
                        </GridItem>
                    </div>
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}

PdfAnalytics.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(PdfAnalytics);
